import React from 'react';
import { api } from '@/lib/api';
import { SaveWithVersionDialog } from '@/components/SaveWithVersionDialog';
import { StatsDialog } from './StatsDialog';
import { ExportDialog } from './ExportDialog';
import { FieldPropertiesDialog } from './FieldPropertiesDialog';
import { BrowseDataDialog } from './BrowseDataDialog';
import { QueryViewDialog } from './QueryViewDialog';
import { VisualContextMenuWrapper } from './VisualContextMenuWrapper';
import { VisualPlacementDialog } from './VisualPlacementDialog';
import { AlertFromVizDialog } from './AlertFromVizDialog';
import { CorrelationDialog } from './CorrelationDialog';

/**
 * All modal/dialog overlays used by the report builder, grouped so the
 * page body stays focused on the canvas itself. Parent owns all state.
 */
export default function BuilderDialogs(props) {
  const {
    // Visual right-click context menu
    visualCtxMenu, setVisualCtxMenu, visuals, designerMode, reportId,
    setLibraryVisuals, updateVisual, handleZIndexChange,
    handleDeleteFromCtx, handleDuplicateFromCtx, handleCreateAlertFromViz,
    // Visual placement dialog (report mode)
    vizPlacementOpen, confirmVizPlacement,
    // Stats / Export / Props / Browse / Query dialogs
    statsOpen, setStatsOpen, result, queryExplanation,
    exportOpen, setExportOpen, exportFormat, setExportFormat,
    exportSettings, setExportSettings, exporting, handleExport,
    propsOpen, setPropsOpen, propsField, propsForm, setPropsForm, allFields, saveFieldProperties,
    browseOpen, setBrowseOpen, browseField, browseData, browseLoading, formatValue,
    UnsavedDialog,
    saveDialogOpen, setSaveDialogOpen, saveReport, saving, reportName, reportVersion,
    ConfirmDialogElement,
    queryViewOpen, setQueryViewOpen, queryViewVisualId, visualQueryInfo,
    alertFromVizOpen, setAlertFromVizOpen, alertFromVizData, setAlertFromVizData,
    corrPopupData, setCorrPopupData, setVizConfig,
  } = props;

  const saveTitle = reportId
    ? (designerMode === 'report' ? 'Save Report' : 'Save Insight')
    : (designerMode === 'report' ? 'Create Report' : 'Create Insight');

  return (
    <>
      <VisualContextMenuWrapper
        visualCtxMenu={visualCtxMenu} setVisualCtxMenu={setVisualCtxMenu}
        visuals={visuals} designerMode={designerMode}
        reportId={reportId} api={api}
        setLibraryVisuals={setLibraryVisuals}
        updateVisual={updateVisual}
        handleZIndexChange={handleZIndexChange}
        handleDeleteFromCtx={handleDeleteFromCtx}
        handleDuplicateFromCtx={handleDuplicateFromCtx}
        handleCreateAlertFromViz={handleCreateAlertFromViz}
      />
      <VisualPlacementDialog open={vizPlacementOpen} onConfirm={confirmVizPlacement} />
      <StatsDialog open={statsOpen} onOpenChange={setStatsOpen} result={result} queryExplanation={queryExplanation} allFields={allFields} />
      <ExportDialog
        open={exportOpen} onOpenChange={setExportOpen}
        exportFormat={exportFormat} setExportFormat={setExportFormat}
        exportSettings={exportSettings} setExportSettings={setExportSettings}
        exporting={exporting} result={result} onExport={handleExport}
      />
      <FieldPropertiesDialog
        open={propsOpen} onOpenChange={setPropsOpen}
        propsField={propsField} propsForm={propsForm} setPropsForm={setPropsForm}
        allFields={allFields} onSave={saveFieldProperties}
      />
      <BrowseDataDialog
        open={browseOpen} onOpenChange={setBrowseOpen}
        browseField={browseField} browseData={browseData} browseLoading={browseLoading}
        formatValue={formatValue}
      />
      <UnsavedDialog />
      <SaveWithVersionDialog open={saveDialogOpen} onOpenChange={setSaveDialogOpen} onSave={saveReport} saving={saving} title={saveTitle} nextVersion={reportVersion != null ? reportVersion + 1 : 1} />
      <ConfirmDialogElement />
      <QueryViewDialog
        open={queryViewOpen} onOpenChange={setQueryViewOpen}
        visualId={queryViewVisualId} queryInfo={visualQueryInfo} allFields={allFields}
      />
      <AlertFromVizDialog
        open={alertFromVizOpen} onOpenChange={setAlertFromVizOpen}
        alertData={alertFromVizData} setAlertData={setAlertFromVizData}
      />
      <CorrelationDialog
        corrPopupData={corrPopupData} setCorrPopupData={setCorrPopupData}
        setVizConfig={setVizConfig}
      />
    </>
  );
}
